import React, { useState, useRef } from "react";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { Input } from "../Modals/DocumentModal/DocumentModal.styles";
import TimePicker from "../TimePicker/TimePicker";

interface TimePickerInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const TimePickerInput: React.FC<TimePickerInputProps> = ({
  value,
  onChange,
  placeholder,
}) => {
  const [isTimePickerOpen, setIsTimePickerOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(containerRef, () => setIsTimePickerOpen(false));
  return (
    <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
      <Input
        value={value}
        placeholder={placeholder}
        onClick={() => setIsTimePickerOpen(true)}
        readOnly
      />
      {isTimePickerOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            zIndex: 1000,
          }}
        >
          <TimePicker value={value} onChange={onChange} />
        </div>
      )}
    </div>
  );
};

export default TimePickerInput;
